import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import ExternalLink from "../components/ExternalLink";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Get in touch 😀`}</h2>
    <p>{`I'd love to hear your ideas and how I can help!`}</p>
    <p>{`You can write to me `}<ExternalLink href="mailto:anneraj73@gmail.com" mdxType="ExternalLink">{`here`}</ExternalLink>{` or contact me at `}<ExternalLink href="https://www.linkedin.com/in/annedeepa/" mdxType="ExternalLink">{`LinkedIn`}</ExternalLink></p>
    <p>{`Do stop by and take a look here too: `}<ExternalLink href="https://github.com/DeepaPrasanna" mdxType="ExternalLink">{`GitHub`}</ExternalLink></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      